<template>
        <router-view></router-view>
</template>

<script>
    export default {
        name: "Router"
    }
</script>

<style scoped>

</style>